export default function isAppWebview() {
  const isAndroidWebview =
    globalThis?.navigator?.userAgent?.indexOf('EuropaParkApp/') > -1;
  const isIOsWebview =
    globalThis?.navigator?.userAgent?.indexOf('Europapark/') > -1;

  return isAndroidWebview || isIOsWebview;
}
